export default __webpack_public_path__ + "static/media/svg-decorator-blob-6.e51c38af.svg";